export class OrganizationDTO {
  createdAt
  orgId
  orgName
  users
  updatedAt
  /** @type {import('../models').OrgSettings} */
  settings
}
